import { Reveal } from "./primitives";

const outlets = [
  "CNN",
  "Extra",
  "Today",
  "NBC Nightly News",
  "Headline News",
  "Tamron Hall",
  "Good Morning America",
];

export const PressBar = () => (
  <section data-testid="press-bar" className="border-y border-ink/10 bg-alabaster py-10 md:py-12">
    <div className="mx-auto max-w-[1400px] px-6 md:px-10">
      <Reveal>
        <div className="flex flex-col items-center gap-6 md:flex-row md:gap-10">
          <span className="shrink-0 font-sans text-[0.7rem] uppercase tracking-[0.32em] text-terracotta">
            As seen on
          </span>
          <div className="hidden h-4 w-px bg-ink/15 md:block" />
          <ul className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3 md:justify-start md:gap-x-10">
            {outlets.map((o) => (
              <li
                key={o}
                data-testid={`press-${o.toLowerCase().replace(/\s/g, "-")}`}
                className="font-display text-lg italic text-ink/70 transition-colors duration-300 hover:text-ink md:text-xl"
              >
                {o}
              </li>
            ))}
          </ul>
        </div>
      </Reveal>
    </div>
  </section>
);
